import { ValueDisplayValue } from "@mcleod/core";
import { ImageName } from "@mcleod/images";
import { Label, Panel, PanelProps, RadioBox, Switch } from "../..";
import { Cursor } from "../base/Cursor";
import { Tab } from "../components/tabset/Tab";
import { Tabset } from "../components/tabset/Tabset";
import { TabStyle } from "../components/tabset/TabsetProps";

export interface TabsetConfigPanelProps extends PanelProps {
    selectedStyle: TabStyle;
    tabsset: Tabset;
}

export class TabsetConfigPanel extends Panel implements TabsetConfigPanel {
    radioBox: RadioBox;
    panelTabs: Panel;
    _tabset: Tabset;
    dragPanel: Panel;

    constructor(props?: Partial<TabsetConfigPanelProps>) {
        super({ id: props?.id, padding: 24, paddingTop: 8 });
        this.radioBox = new RadioBox({
            caption: "View as",
            items: [
                new ValueDisplayValue(TabStyle.OUTLINED),
                new ValueDisplayValue(TabStyle.UNDERLINED),
                new ValueDisplayValue(TabStyle.ACCORDION),
                new ValueDisplayValue(TabStyle.SCROLL)
            ],
            marginBottom: 12
        })
        this.add(this.radioBox);
        this.add(new Label({ text: "Tab order (drag items to change the order)", fontSize: "large" }))
        this.panelTabs = new Panel({ fillHeight: true, fillRow: true });
        this.add(this.panelTabs);
        this.setProps(props);
        this.radioBox.addAfterSelectionListener((event) => {
            this.tabset.tabStyle = event.newValue.value;
        });
    }

    get selectedStyle(): TabStyle {
        return Object.values(TabStyle)[this.radioBox.selectedValue];
    }

    set selectedStyle(value: TabStyle) {
        this.radioBox.setSelectedFromValue(value);
    }

    get tabset() {
        return this._tabset;
    }

    set tabset(value: Tabset) {
        this._tabset = value;
        this.panelTabs.removeAll();
        for (const comp of value.components) {
            const tab = comp as Tab;
            const tabPanel = new Panel({
                rowBreakDefault: false,
                fillRow: true,
                borderWidth: 1,
                borderColor: "subtle.darker",
                draggable: true,
                marginBottom: 4,
                borderRadius: 4,
                cursor: Cursor.GRAB,
            });
            (tabPanel as any).tab = tab;
            const label = new Label({ text: tab.caption, fillRow: true, imageName: ImageName.menuHamburger, color: "success" });
            const switchOpen = new Switch({ leftCaption: "Closed", rightCaption: "Open" });
            tabPanel.add(label, switchOpen);
            tabPanel.addMouseDownListener(event => {
                tabPanel.backgroundColor = "background4";
                tabPanel.cursor = Cursor.GRABBING;
            });
            tabPanel.addMouseUpListener(event => {
                tabPanel.cursor = Cursor.GRAB;
                tabPanel.backgroundColor = "transparent";
            });
            tabPanel.addDragStartListener(event => {
                this.dragPanel = tabPanel;
            });
            tabPanel.addDragEndListener(event => {
                tabPanel.cursor = Cursor.GRAB;
                tabPanel.backgroundColor = "transparent";
            });
            tabPanel.addDragOverListener(event => {
                if (this.dragPanel != tabPanel) {
                    this.tabset.swap((tabPanel as any).tab, (this.dragPanel as any).tab)
                    this.panelTabs.swap(tabPanel, this.dragPanel);
                }
                event.preventDefault();
            });
            this.panelTabs.add(tabPanel);
        }
    }
}
